/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Media Plans API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReachCurveType = {
    Base: 'base',
    AttentionAdjusted: 'attention_adjusted'
} as const;
export type ReachCurveType = typeof ReachCurveType[keyof typeof ReachCurveType];


export function ReachCurveTypeFromJSON(json: any): ReachCurveType {
    return ReachCurveTypeFromJSONTyped(json, false);
}

export function ReachCurveTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReachCurveType {
    return json as ReachCurveType;
}

export function ReachCurveTypeToJSON(value?: ReachCurveType | null): any {
    return value as any;
}

